// extracted by mini-css-extract-plugin
export default {"cardWrapper":"B7JxlZ","cardImage":"UIG_DR","badge":"GhWFYk","priceContainer":"mEGIoz"};